/** 
 * api接口的统一出口
 */
// 影音模块接口
import VideoApi from '../Video/VideoApi';
import permissionApi from '../Permission/PermissionApi';
import TopicApi from '../Topic/TopicAPi'
import EventApi from '../Event/EventApi'
import BannerApi from '../Banner/BannerApi'
import common from '../login/common';
import commons from '../common/commons'
import albumApi from '../album/albumApi'
import social from '../social/social'
import report from '../report/report'
import blog from "../blog/blogApi"
import { get, post } from './http'
import ad from '../ad/adApi'
import medalApi from "../admedal/medalApi";
// 其他模块的接口……

// 导出接口
export default {
  VideoApi,
  common,
  commons,
  permissionApi,
  TopicApi,
  EventApi,
  albumApi,
  BannerApi,
  social,
  report,
  ad,
  blog,
  medalApi
  // ……
};


// WEBPACK FOOTER //
// ./src/api/httpApi/index.js